import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const MAX_AUTO_RETRIES = 2;
const RETRY_STORAGE_KEY = "invalidPathRetryCount";

const InvalidPathFallback = () => {
  const [retriesLeft, setRetriesLeft] = useState(null);

  useEffect(() => {
    const attemptsSoFar = Number(sessionStorage.getItem(RETRY_STORAGE_KEY)) || 0;

    if (attemptsSoFar < MAX_AUTO_RETRIES) {
      sessionStorage.setItem(RETRY_STORAGE_KEY, String(attemptsSoFar + 1));
      window.location.reload();
    } else {
      setRetriesLeft(0);
    }
  }, []);

  const handleManualRefresh = () => {
    sessionStorage.removeItem(RETRY_STORAGE_KEY);
    window.location.reload();
  };

  if (retriesLeft === null) {
    // Auto-retry in progress; page is about to reload.
    return <div>InvalidPath</div>;
  }

  return (
    <div>
      InvalidPath
      <div>
        <button onClick={handleManualRefresh}>Refresh</button>
      </div>
    </div>
  );
};

const InvalidPath = () => {
  const location = useLocation();

  // Handle URLs like:
  // https://rate.lokaci.com/?/abc
  const key = location.search.replace(/^\?+\/?/, "").trim();

  if (key) {
    return <Navigate to={`/${key}`} replace />;
  }

  return <InvalidPathFallback />;
};

export default InvalidPath;